import { render, staticRenderFns } from "./ApplicantMessageBody.vue?vue&type=template&id=9632cd7e"
import script from "./ApplicantMessageBody.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports